<pr-d3-chart
  *ngIf="chart$ | async as chart"
  [label]="chart.label"
  [renderer]="chart.renderer"
 />
